import { render, staticRenderFns } from "./AdditionalVehicleInterestComponent.vue?vue&type=template&id=56e9ea41"
import script from "./AdditionalVehicleInterestComponent.vue?vue&type=script&lang=ts"
export * from "./AdditionalVehicleInterestComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports